<template>
    <div>
        <div class="dmap-window" :class="{'hide-map': !isRequisitionMap && !getToggleMapState }" :style="mapStyle()">
            <div v-if="!getToggleMapState && resizer" class="dmap-resizer" @mousedown="down" @touchmove="down"></div>
            <n-map class="dmap-component" :config="config" />
            <button class="flexbox-center show-for-small-only floating-button" v-if="resizer" @click="toggleMapState(false)">
                <span class="visually-hidden">Liste</span>
                <icon name="task-check" class="medium-svg fill-white" />
            </button>
            <!-- Existing work -->
            <existing-work v-if="existingWork" :existingWork="existingWork"/>
            <facility-tree v-if="existingTask" @facilityVisible="facilityVisible" />

            <div class="new-drawed-object" :class="{isHidden: !newDrawedObjectIsVisible}">
                <div class="grid-x new-drawed-object-header align-items">
                    <div>
                        <icon class="location-svg medium-svg fill-medium-gray" name="pencil" />
                    </div>
                    <div class="cell auto">
                        <span> Navngiv tegnet objekt</span>
                    </div>
                </div>
                <div class="grid-x align-items">
                    <div class="form">
                        <div class="grid-x">
                            <div class="cell auto border-bottom">
                                <input type="text" v-model="newDrawedObjectName" ref="objectName" maxlength="250">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="grid-x">
                    <div class="cell flexbox-center">
                        <button class="text-center buttons-map" @click="saveNewDrawedObject()">
                            Gem navn
                        </button>
                        <button class="text-center buttons-map" @click="clearNewDrawedObject()">
                            Fortryd
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <modal v-if="showModal" :type="modalType" :data="modalData" @close="closeModal" />
    </div>
</template>

<script>
import { NMap, NMapConfig, NMapLayerWmsKortInfo, NMapKortInfoApi, NMapLayerGroup, NMapLayerControl, NMapLayerArcGis, NMapUtils,
    NMapLayerVector, NMapFeature, NMapCoordinates, NMapStyle, NMapStyleCircle, NMapLayerWms, NMapButton, NMapGeoLocationButton, NMapLayerWmsGeoServer} from 'ncomponents-map'
import { mapGetters, mapActions } from 'vuex'
import existingWork from './../list/list-existing-work.vue'
import FacilityTree from '@/components/shared/TheFacilityTree.vue'
import modal from './../modal/modal.vue'

export default {
    name: 'BaseMap',
    components: {
        modal,
        'n-map': NMap,
        'existing-work': existingWork,
        FacilityTree
    },
    props: {
        config: {
            type: NMapConfig,
            default () {
                return new NMapConfig()
            }
        },
        supplyCode: {
            type: Number,
            required: true
        },
        supplyTypeId: {
            type: String,
            required: true
        },
        existingWork: {
            type: Object,
            default: null
        },
        isRequisitionMap: {
            type: Boolean,
            default: false
        },
        locationWkt: {
            type: String
        },
        buttonSelected: {
            default () {
                return {
                    info: false,
                    layer: false
                }
            }
        },
        resizer: {
            type: Boolean,
            default: true
        },
        highlightedObject: null,
        existingTask: false,
        vectorLayerClicked: false
    },
    data () {
        return {
            active: false,
            moved: false,
            width: this.resizer ? 38 : 100,
            bBox: null,
            backgroundPromise: null,
            kiPages: null,
            maxZoom: 20,
            newDrawedObjectIsVisible: false,
            newDrawedObjectName: null,
            newDrawedObjectwkt: null,
            showModal: false,
            modalType: null,
            modalData: null,
            highlightLayer: null,
            vectorLayer: null,
            selectedObjectLayer: null,
            DrawLayer: null,
            zoomLimit: 13.5,
            getTaskTimeout: null
        }
    },
    computed: {
        ...mapGetters({
            getToggleMapState: 'getToggleMapState',
            applicationSettings: 'getApplicationSettings'
        })
    },
    watch: {
        supplyCode (val, oldVal) {
            // When user switches supply then re-populate the map
            this.backgroundPromise.then(this.populate)
        },
        locationWkt (val, oldVal) {
            // When user moves pin
            this.navigateTo(val)
        },
        'buttonSelected.info': function (val) {
            if (val) {
                document.querySelector('.info-object-button').classList.add('selected')
            } else {
                document.querySelector('.info-object-button').classList.remove('selected')
            }
        }
    },
    created () {
        NMapUtils.registerProjection('EPSG:25832', '+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs')
        NMapUtils.setLanguage('da')

        // Start creation of buttons
        this.createButtons()

        // Layer information and supply code
        // This needs to be resolved before able to populate & navigate & highlight the map
        this.backgroundPromise = Promise.all(
            this.applicationSettings.kortinfoSettings.filter(i => i).map(i => {
                return new Promise(resolve => {
                    if (i.mapServiceList.length > 0) {
                        i.mapServiceList.forEach(map => {
                            if (map.type === 'kortinfo') {
                                const mapApi = new NMapKortInfoApi({
                                    site: map.kortInfoSite, // i.kortinfoSite,
                                    page: map.kortInfoPage, // i.KortInfoPage
                                    apiKey: '2JCZUW5X9KY4G0T1GNGWB'
                                })
                                mapApi.getPage().then(page => {
                                    resolve({
                                        page: page,
                                        supplyCode: this.applicationSettings.kortinfoSettings.indexOf(i)
                                    })
                                })
                            }
                        })
                    } else {
                        // The map has no map service list
                        resolve({
                            page: null,
                            supplyCode: this.applicationSettings.kortinfoSettings.indexOf(i)
                        })
                    }
                })
            })
        ).then(pages => {
            this.kiPages = pages
            // This populates the map with initialized supplyType
            this.populate()
            // Navigates to bounding box or supplied point
            if (!this.moved) {
                this.navigateTo(this.locationWkt) // Problem here that it overwrites the fitAllObjects
            }
        })
    },
    methods: {
        ...mapActions({
            setNewCreatedObject: 'setNewCreatedObject',
            setRemoveObject: 'setRemoveObject',
            toggleMapState: 'toggleMapState'
        }),

        navigateTo (navigateToWkt) {
            this.backgroundPromise.then(promise => {
                if ((navigateToWkt !== undefined || null) && navigateToWkt !== 'POINT EMPTY') {
                    const marker = NMapFeature.createMarker(new NMapCoordinates(navigateToWkt, 'EPSG:25832'), '#5293bc')
                    if (this.vectorLayer) {
                        this.vectorLayer.clear()
                        this.vectorLayer.addFeature(marker)
                    }
                    this.config.fit(marker, {
                        maxZoom: this.maxZoom
                    })
                    // Get wkt of map?
                    // getBoundedObjects?
                } else if (this.bBox) {
                    this.config.fit(this.bBox)
                }
                this.moved = true
            })
        },
        preventBackgroundScroll (event) {
            event.stopPropagation()
        },
        createButtons () {
            // Layer button
            const lc = new NMapLayerControl({
                map: this.config,
                baseHeading: 'Baggrundskort',
                overlayHeading: 'Lag'
            })

            lc.on('click', () => {
                if (this.buttonSelected.layer === true) {
                    const manager = document.querySelector('.nmap-layer-control')
                    if (manager) {
                        manager.removeEventListener('touchmove', this.preventBackgroundScroll)
                    }
                    lc.close()
                    this.buttonSelected.layer = false
                } else {
                    this.buttonSelected.layer = true
                    this.$nextTick(() => {
                        const manager = document.querySelector('.nmap-layer-control')
                        if (manager) {
                            manager.addEventListener('touchmove', this.preventBackgroundScroll, { passive: false })
                        }
                    })
                }
            })

            // Info button
            const mapButtonInfo = new NMapButton({
                content: 'i',
                title: 'Vis informationer',
                cls: 'info-object-button'
            })

            mapButtonInfo.on('click', () => {
                this.config.cancelDraw()
                if (!this.buttonSelected.info) {
                    this.$emit('infoActive', true)
                    this.setButtons('info')

                    const handler = (e) => {
                        if (this.buttonSelected.info) {
                            this.setButtons('')
                            this.$emit('infoActive', false)
                            document.querySelector('.info-object-button').classList.remove('selected')
                            const layers = []
                            // WMS & ArcGIS
                            e.layers.forEach(l => {
                                if (l.layer instanceof NMapLayerWms) {
                                    layers.push({
                                        name: l.layer.manager.name ? l.layer.manager.name : l.layer.cargo.objectlayer[0].layername,
                                        features: l.features.map((f, i) => {
                                            // Find the layer of the feature
                                            const featureLayer = l.layer.cargo ? l.layer.cargo.layers.find(layer => layer.id === f.layerId) : null
                                            return {
                                                name: `objekt ${(i + 1)}`,
                                                updateable: featureLayer ? featureLayer.updateable : false,
                                                layerId: f.layerId ? f.layerId : null,
                                                layerName: featureLayer ? featureLayer.name : null,
                                                geometry: f.geometry ? f.geometry.wkt('EPSG:25832') : null,
                                                dataSourceId: featureLayer ? featureLayer.dataSourceId : '',
                                                objectIdPropertyName: featureLayer ? featureLayer.objectIdPropertyName : null,
                                                properties: (f.properties.filter(p => p.value !== null).map(p => {
                                                    return {
                                                        name: p.name,
                                                        value: p.value
                                                    }
                                                }))
                                            }
                                        })
                                    })
                                } else if (l.layer instanceof NMapLayerArcGis) {
                                    const layerIds = l.features.map(feature => feature.layerId)

                                    layerIds.forEach((layerId) => {
                                        const features = l.features.filter(feature => feature.layerId === layerId)

                                        if (l.layer.cargo.layers.find(layer => parseInt(layer.id) === layerId)) {
                                            layers.push({
                                                // Find all features with matching layerID
                                                name: l.features.find(feature => feature.layerId === layerId).layerName,
                                                features: features.map((feature, index) => {
                                                    const updateable = l.layer.cargo.layers.find(layer => layer.id === feature.layerId)
                                                    return {
                                                        name: `Objekt ${(index + 1)}`,
                                                        updateable: updateable !== 'undefined' ? updateable : false, // MANGLER
                                                        geometry: feature.geometry ? feature.geometry.wkt('EPSG:25832') : null,
                                                        properties: (feature.properties.filter(property => property.value !== null).map(property => {
                                                            return {
                                                                name: property.name,
                                                                value: property.value
                                                            }
                                                        }))
                                                    }
                                                })
                                            })
                                        }
                                    })
                                }
                            })
                            if (layers.length > 0) {
                                const data = {
                                    layers: layers,
                                    editOnLoad: false
                                }

                                this.openModal('properties-modal', data)
                            } else {
                                this.openModal('plain-information-modal', 'Ingen objekter fundet')
                            }

                            if (this.vectorLayerClicked) {
                                this.closeModal()
                                this.vectorLayerClicked = false
                            }
                        }
                    }
                    this.config.once('getFeatures', handler)
                } else {
                    // Double click on the button, therefore disable it
                    this.setButtons('')
                    this.$emit('infoActive', false)
                }
            })

            // GPS button
            const geoButton = new NMapGeoLocationButton({
                title: 'Find min lokation',
                zoom: 20
            })

            geoButton.on('click', (event) => {
                navigator.geolocation.getCurrentPosition((position) => {
                    const markerLayer = new NMapLayerVector({
                        name: 'Marker',
                        visible: true,
                        hidden: true
                    })
                    const marker = NMapFeature.createMarker(new NMapCoordinates(position.coords.longitude, position.coords.latitude, 'EPSG:4326'), '#3d68e1')

                    this.config.addLayer(markerLayer)
                    markerLayer.clear()
                    markerLayer.addFeature(marker)
                })
            })

            // Add buttons to config
            this.config.addControl(lc, 0)
            this.config.addControl(geoButton)
            this.config.addControl(mapButtonInfo)

            this.config.on('moved', (e) => {
                clearTimeout(this.getTaskTimeout)
                this.getTaskTimeout = setTimeout(() => this.boundingBox(), 20)
            })
        },
        populate () {
            if (this.supplyCode) {
                this.config.clearLayers()
                const setting = this.applicationSettings.kortinfoSettings[this.supplyCode]
                const kiPage = this.kiPages.find(s => s.supplyCode === this.supplyCode)
                if (kiPage.page !== null) {
                    kiPage.page.backgroundLayers.forEach(l => {
                        const layer = new NMapLayerWmsKortInfo({
                            base: true,
                            name: l.name,
                            url: kiPage.page.wmsUrl,
                            layer: l.layerId,
                            projection: 'EPSG:25832'
                        })
                        this.config.addLayer(layer)

                        // Without this it will default to the first map
                        if (l.layerId === kiPage.page.defaultBackgroundLayerId) {
                            this.config.layerManager.selectBaseLayer(layer)
                        }
                    })

                    kiPage.page.themeTrees.forEach(t => {
                        const group = new NMapLayerGroup({
                            name: t.name
                        })
                        this.config.addLayer(group)

                        t.folders.forEach(f => {
                            const subgroup = new NMapLayerGroup({
                                name: f.name
                            })
                            f.layers.forEach(l => {
                                const layer = new NMapLayerWmsKortInfo({
                                    name: l.name,
                                    url: kiPage.page.wmsUrl,
                                    layer: l.layerId,
                                    visible: l.visible,
                                    tileMode: 'single',
                                    projection: 'EPSG:25832'
                                })
                                // Finde layer's objectlayer
                                layer.cargo = setting.mapServiceList.find(map => {
                                    map.type === 'kortinfo' && map.layers.some(o => o.id === l.layerId)
                                })
                                subgroup.addLayer(layer)
                            })
                            group.addLayer(subgroup)
                        })

                        t.layers.forEach(l => {
                            const layer = new NMapLayerWmsKortInfo({
                                name: l.name,
                                url: kiPage.page.wmsUrl,
                                layer: l.layerId,
                                visible: l.visible,
                                hidden: true,
                                tileMode: 'single',
                                projection: 'EPSG:25832'
                            })
                            layer.cargo = setting.mapServiceList.find(map => {
                                map.type === 'kortinfo' && map.layers.some(o => o.id === l.layerId)
                            })
                            group.addLayer(layer)
                        })
                    })

                    if (setting.mapServiceList.length > 0) {
                        setting.mapServiceList.filter(s => s.Type !== 'kortinfo').forEach((s, index) => {
                            if (s.type === 'arcgis') {
                                const layer = new NMapLayerArcGis({
                                    name: 'Objekter',
                                    url: s.url,
                                    params: {
                                        LAYERS: 'show:' + s.layers.map(l => l.id).join(',') // s.layers.map(l => l.id).join(',')
                                    },
                                    visible: true,
                                    hidden: true,
                                    tileMode: 'single',
                                    projection: 'EPSG:25832'
                                })
                                layer.cargo = s

                                this.config.addLayer(layer)
                            } else if (s.type === 'ogc') {
                                const layer = new NMapLayerWmsGeoServer({
                                    name: 'Objekter',
                                    url: s.url,
                                    params: {
                                        LAYERS: s.layers.map(l => l.id).join(',')
                                    },
                                    visible: true,
                                    hidden: true,
                                    tileMode: 'single',
                                    projection: 'EPSG:25832'
                                })
                                layer.cargo = s

                                this.config.addLayer(layer)
                            } else if (s.type === 'ogckortinfo') {
                                const layer = new NMapLayerWms({
                                    name: 'Objekter',
                                    url: s.url,
                                    params: {
                                        LAYERS: s.layers.map(l => l.id).join(','),
                                        VERSION: '1.1.1'
                                    },
                                    visible: true,
                                    hidden: true,
                                    tileMode: 'single',
                                    projection: 'EPSG:25832'
                                })
                                layer.cargo = s

                                this.config.addLayer(layer)
                            }
                        })
                    }

                    this.vectorLayer = new NMapLayerVector({
                        name: 'vector',
                        hidden: true
                    })
                    this.config.addLayer(this.vectorLayer)

                    this.highlightLayer = new NMapLayerVector({
                        name: 'highlight',
                        hidden: true,
                        visibleMinZoom: 14.5
                    })

                    this.highlightLayer.on('select', (objects) => {
                        if (this.highlightedObject) {
                            if (objects.records instanceof Array) {
                                this.highlightedObject(objects)
                            } else {
                                this.highlightedObject([objects])
                            }
                        }
                        this.highlightSelectedObjects([objects.feature.cargo])
                    })

                    this.config.addLayer(this.highlightLayer)

                    this.selectedObjectLayer = new NMapLayerVector({
                        name: 'selectedobject',
                        hidden: true,
                        visibleMinZoom: 16
                    })
                    this.config.addLayer(this.selectedObjectLayer)

                    this.DrawLayer = new NMapLayerVector({
                        name: 'draw',
                        hidden: true
                    })
                    this.config.addLayer(this.DrawLayer)

                    if (kiPage.page.boundingBox) {
                        this.bBox = kiPage.page.boundingBox
                    }
                }
            }
        },
        fitAllObjects (objects) {
            this.backgroundPromise.then(promise => {
                let features = []
                let wkts
                if (typeof objects === 'string') {
                    wkts = [objects]
                } else {
                    wkts = objects.filter(o => o.geomWkt).map(o => o.geomWkt)
                }

                wkts.forEach(wkt => {
                    features.push(new NMapFeature({
                        sourceType: 'wktGeometry',
                        projection: 'EPSG:25832',
                        source: wkt
                    }))
                })
                this.config.fit(features, {
                    maxZoom: this.maxZoom
                })
            })
        },
        highlightObjects (objects) {
            this.backgroundPromise.then(promise => {
                if (this.highlightLayer) {
                    this.highlightLayer.clear()
                }
                if (this.selectedObjectLayer) {
                    this.selectedObjectLayer.clear()
                }

                objects.forEach(obj => {
                    if (obj.geomWkt !== null || obj.geomWkt !== '') {
                        // let objectColor = '#1D49BF' // BLUE
                        let objectColor = '#FFD166' // YELLOW
                        const wkt = obj.geomWkt

                        if (obj.activityList) {
                            let activityListStatus = ''

                            if (!obj.activityList[0].createdByContactor && obj.activityList[0].reportWorkDone === false) {
                                activityListStatus = 'fail'
                            } else if (!obj.activityList[0].createdByContactor && obj.activityList[0].reportWorkDone === true) {
                                activityListStatus = 'success'
                            }
                            if (activityListStatus === 'fail') {
                                // When all activities on an object are marked as unsuccessful
                                objectColor = '#DB370F' // RED
                            }
                            if (activityListStatus === 'success') {
                                // When all activities on an object are marked as successful
                                objectColor = '#00A63F' // GREEN
                            }
                        }

                        if (wkt && (wkt.includes('POINT') || wkt.includes('Point'))) {
                            // Eks. Lyspunkt
                            const newPoint = new NMapCoordinates(wkt, 'EPSG:25832')
                            this.highlightLayer.addFeature(new NMapFeature({
                                sourceType: 'coordinates',
                                style: new NMapStyleCircle({
                                    fillColor: objectColor,
                                    strokeOpacity: 0,
                                    radius: 7
                                }),
                                hoverStyle: new NMapStyleCircle({
                                    fillColor: objectColor,
                                    strokeOpacity: 0,
                                    radius: 9
                                }),
                                source: newPoint,
                                cargo: obj
                            }))
                        } else if (wkt) {
                            // Eks. Kabel
                            this.highlightLayer.addFeature(new NMapFeature({
                                sourceType: 'wktGeometry',
                                style: new NMapStyle({
                                    fillOpacity: 0,
                                    strokeColor: objectColor,
                                    strokeWidth: 4
                                }),
                                hoverStyle: new NMapStyle({
                                    fillOpacity: 0,
                                    strokeColor: objectColor,
                                    strokeWidth: 6
                                }),
                                projection: 'EPSG:25832',
                                source: wkt,
                                cargo: obj
                            }))
                        }
                    }
                })
            })
        },
        highlightSelectedObjects (objects) {
            this.backgroundPromise.then(promise => {
                let objectColor = '#1D49BF' // BLUE
                let highlightColor = '#FF8D26' // ORANGE

                if (this.selectedObjectLayer) {
                    this.selectedObjectLayer.clear()
                }

                if (!(objects instanceof Array)) {
                    objects = [objects]
                }

                if (objects !== null) {
                    objects.forEach(obj => {
                        let wkt = null
                        if (obj.geomWkt) {
                            wkt = obj.geomWkt
                        } else if (obj !== null) {
                            wkt = obj
                        }

                        if (wkt !== null) {
                            if (obj.activityList) {
                                let activityListStatus = ''

                                if (!obj.activityList[0].createdByContactor && obj.activityList[0].reportWorkDone === false) {
                                    activityListStatus = 'fail'
                                } else if (!obj.activityList[0].createdByContactor && obj.activityList[0].reportWorkDone === true) {
                                    activityListStatus = 'success'
                                }

                                if (activityListStatus === 'fail') {
                                    // When all activities on an object are marked as unsuccessful
                                    objectColor = '#DB370F' // RED
                                }
                                if (activityListStatus === 'success') {
                                    // When all activities on an object are marked as successful
                                    objectColor = '#00A63F' // GREEN
                                }
                            }

                            if (wkt && (wkt.includes('POINT') || wkt.includes('Point'))) {
                                // Eks. Lyspunkt
                                const newPoint = new NMapCoordinates(wkt, 'EPSG:25832')
                                this.selectedObjectLayer.addFeature(new NMapFeature({
                                    sourceType: 'coordinates',
                                    style: new NMapStyleCircle({
                                        fillColor: highlightColor,
                                        strokeColor: objectColor,
                                        strokeWidth: 4,
                                        radius: 7
                                    }),
                                    hoverStyle: new NMapStyleCircle({
                                        fillColor: highlightColor,
                                        strokeColor: objectColor,
                                        strokeWidth: 2,
                                        radius: 9
                                    }),
                                    // projection: 'EPSG:25832',
                                    source: newPoint,
                                    cargo: obj
                                }))
                            } else if (wkt) {
                                // Eks. Kabel
                                this.highlightLayer.addFeature(new NMapFeature({
                                    sourceType: 'wktGeometry',
                                    style: new NMapStyle({
                                        fillOpacity: 0,
                                        strokeColor: highlightColor,
                                        strokeWidth: 4
                                    }),
                                    hoverStyle: new NMapStyle({
                                        fillOpacity: 0,
                                        strokeColor: highlightColor,
                                        strokeWidth: 6
                                    }),
                                    projection: 'EPSG:25832',
                                    source: wkt,
                                    cargo: obj
                                }))
                            }
                        }
                    })
                }
            })
        },
        zoomAndHighlightObject (object) {
            this.fitAllObjects(object)
            this.highlightSelectedObjects(object)
        },
        doneNewDrawedObject (wkt) {
            this.newDrawedObjectwkt = wkt
            this.newDrawedObjectIsVisible = true
        },
        saveNewDrawedObject () {
            new Promise((resolve, reject) => {
                resolve(this.setNewCreatedObject({
                    name: this.newDrawedObjectName,
                    wkt: this.newDrawedObjectwkt,
                    businessAreaTypeId: this.supplyTypeId
                }))
            }).then(() => {
                this.clearNewDrawedObject()
                this.config.layerManager.getVisibleLayersAsList().filter(layer => layer instanceof NMapLayerWms && !layer.manager.base).forEach(layer => layer.redraw())
            })
        },
        deleteObject (objectID) {
            var confirmation = confirm('Du er ved at slette, er du sikker?')
            if (confirmation) {
                new Promise((resolve, reject) => {
                    resolve(this.setRemoveObject({objectDriveId: objectID}))
                }).then(() => {
                    this.clearNewDrawedObject()
                    this.config.layerManager.getVisibleLayersAsList().filter(l => l instanceof NMapLayerWms && !l.manager.base).forEach(l => l.redraw())
                })
            }
        },
        clearNewDrawedObject () {
            this.newDrawedObjectIsVisible = false
            // this.removeNewDrawedObjectIsVisible = false
            this.newDrawedObjectName = null
            this.newDrawedObjectwkt = null
            this.DrawLayer.clear()
        },
        getFeatureInformation (taskLayer, feature) {
            const setting = this.applicationSettings.kortinfoSettings[this.supplyCode]
            const newFeature = {
                objectDescription: ''
            }
            const sourceLayer = setting.datasource.map(s => {
                return s.objectlayer.find(l => {
                    if (s.WmsServiceType === 'arcgis' && feature.layerId) {
                        if (l.LayerId === feature.layerId.toString() && l.layername === feature.layerName) {
                            return true
                        }
                    } else if (s.WmsServiceType === 'kortinfo' && taskLayer.layer.manager.name === l.layername) { // layer.layerid
                        return true
                    }
                })
            })
            console.log(sourceLayer, newFeature)
        },
        mapStyle () {
            return 'width:' + this.width + '%'
        },
        up () {
            this.active = false
            document.body.removeEventListener('touchmove', this.setWidth)
        },
        down ($event) {
            this.active = true
            document.body.addEventListener('touchmove', this.setWidth)
            this.setWidth($event)
        },
        setWidth (event) {
            if (this.active === true) {
                let clientX = null
                if (event.touches && event.touches.length > 0) {
                    if (event.touches[0].clientX) {
                        clientX = event.touches[0].clientX
                    }
                } else if (!event.touches && event.clientX) {
                    clientX = event.clientX
                }

                if (clientX) {
                    let width = ((document.documentElement.clientWidth - clientX + 15) / document.documentElement.clientWidth) * 100
                    this.width = width
                    this.config.updateSize()
                }
            }
        },
        removeEvent () {
            document.body.removeEventListener('mouseup', this.up)
            document.body.removeEventListener('mousemove', this.setWidth)
            document.body.removeEventListener('touchmove', this.setWidth)
            document.body.removeEventListener('touchend', this.up)
        },
        openModal (type, data) {
            this.showModal = true
            this.modalType = type
            this.modalData = data
        },
        closeModal () {
            this.showModal = false
        },
        setButtons (val) {
            Object.keys(this.buttonSelected).forEach(button => {
                if (button === val) {
                    this.buttonSelected[button] = true
                } else {
                    this.buttonSelected[button] = false
                }
            })
        },
        checkZoomLevel () {
            if (this.config !== null) {
                return this.config.getZoom()
            }
            return 0
        },
        boundingBox () {
            const boundingBox = this.config.getBoundingBox()
            const bounds = {
                xMin: boundingBox.bottomLeft.project('EPSG:25832').x,
                yMin: boundingBox.bottomLeft.project('EPSG:25832').y,
                xMax: boundingBox.topRight.project('EPSG:25832').x,
                yMax: boundingBox.topRight.project('EPSG:25832').y
            }
            const inZoomRange = this.checkZoomLevel() >= this.zoomLimit
            this.$emit('getBoundingBox', {bounds, inZoomRange})
        },

        facilityVisible (boolean) {
            if (boolean) {
                this.width = 80
            } else {
                this.width = 38
            }
            this.config.updateSize()
        }
    },
    mounted () {
        if (screen.width >= 760) {
            let _this = this
            document.body.addEventListener('mouseup', _this.up)
            document.body.addEventListener('mousemove', _this.setWidth)
            document.body.addEventListener('touchend', _this.up)
        }
        this.moved = false
    },
    beforeDestroy () {
        this.removeEvent()
    }
}
</script>

<style lang="scss">
@import '../../../scss/components/floating-button.scss';

.nmap-layer-control {
    @media (max-width: 768px) {
        max-height: 70vh;
        overflow-y: auto;
        left: 48px !important;
        -webkit-overflow-scrolling: touch;
      }
}

.base-map-popup-list {
  list-style: none;
  min-width: 220px;
  max-width: 320px;
}

.base-map-popup-item {
  border: 1px solid #e6e6e6;
  border-radius: 6px;
  padding: 8px 12px;
  position: relative;
}
.base-map-popup-item:has(.base-map-popup-item--link) {
  color: #3b637c;
}
.base-map-popup-item:focus-within {
  background: #f5f7fa;
  border-color: #d0d7de;
  color: $color-primary;
}
.base-map-popup-item + .base-map-popup-item {
  margin-top: 8px;
}

.base-map-popup-item--link {
  text-decoration: none;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.base-map-popup-title {
  font-weight: 600;
  line-height: 1.3;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/map/base-map.vue